import ClassHelper from '../ClassHelper';
import DateTZ from '../date/DateTZ';
import Excursion from '../excursion/Excursion';
import Schedule from '../schedule/Schedule';
import Transport from '../transport/Transport';

class OrderDetails extends ClassHelper {
  constructor({ number, date, schedule, excursion, seats = [], transports = [], paidAmount, refundAmount, paymentMethod, status} = {}) {
    super(...arguments);
    this.number = number;
    this.date = this.obj(date, DateTZ);
    this.schedule = this.ref(schedule, Schedule);
    this.excursion = this.ref(excursion, Excursion);
    this.seats = this.array(seats, Number);
    this.transports = this.array(transports, Transport);
    this.paidAmount = paidAmount;
    this.refundAmount = refundAmount;
    this.paymentMethod = paymentMethod; // PaymentMethod
    this.status = status; // OrderStatus
  }
}

export default OrderDetails;